import { z } from 'zod';
import { domainSchema, sourceSiteSchema } from './source';

/** The source sites collection path (QZ-D58). */
export const SOURCES_PATH = '/sources';

/** A single source site's path (QZ-D58). */
export const sourcePath = (domain: string): string => `/sources/${encodeURIComponent(domain)}`;

/** The router pattern matching `sourcePath` (QZ-D58). */
export const SOURCE_PATH_PATTERN = '/sources/:domain';

/** The body returned by `GET /sources` (QZ-D58). */
export const listSourcesResponseSchema = z.object({ sources: z.array(sourceSiteSchema) }).strip();
export type ListSourcesResponse = z.infer<typeof listSourcesResponseSchema>;

/** The body accepted by `POST /sources` (QZ-D58). */
export const addSourceRequestSchema = z.object({ domain: domainSchema }).strict();
export type AddSourceRequest = z.infer<typeof addSourceRequestSchema>;
